import MagstimTable from './MagstimTable';

import { CurrentLang } from 'common';

class MagstimTableNotes extends MagstimTable {


	initForSelect = (data, heightPx) => {
		// console.log(`MagstimTablePatient.initForSelect(${JSON.stringify(data)}, ${heightPx})`);
		this.initTable(this.configTableData(data), heightPx);
	}

	initForEdit = (data, heightPx) => {
		this.initTable(this.configTableData(data), heightPx);
	}

	configTableData(data) {
		return {
			columns: [
                { title: CurrentLang().note_created_time, property: 'CreatedTime', formatter: this.formatDate },
                { title: CurrentLang().note_note, property: 'Note', optional: true, width: '45%' },
                { title: CurrentLang().note_type, property: 'Type',  optional: true},
                { title: CurrentLang().note_added_by, property: 'CreatedByName' },
			],
			data: data
		};
    }
    
    resetFilters() {
		// console.log('MagstimTablePatient.resetFilters');
		super.resetFilters();
		this.addFilter('Type', '');
	}
}

export default MagstimTableNotes;